"use client";

import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@kkeut/lib/firebase/client";

/**
 * Firestore {branchId}/default 에서 지점 설정 로드.
 * phone, instagramLink, blogNaverUrl, tvNaverUrl 등 관리자페이지에서 관리되는 값 사용.
 *
 * @param {string} branchId
 * @returns {{ phone: string, name: any, url: string, region: any, loading: boolean }}
 */
export function useBranchConfig(branchId) {
  const [config, setConfig] = useState({ phone: "", name: "", url: "", region: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!branchId) return;
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db, branchId, "default"));
        if (cancelled) return;
        if (snap.exists()) setConfig(snap.data());
      } catch (e) {
        console.error("[useBranchConfig]", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [branchId]);

  return { ...config, loading };
}
